import type { WorkOrderChangeObjectItem, WorkOrderObjectData } from 'gql/graphql';

import type { ICellRendererParams } from 'ag-grid-community';
import type React from 'react';
import { useMemo } from 'react';

type THierarchyNameCellRenderer = ICellRendererParams<
    (WorkOrderObjectData | WorkOrderChangeObjectItem) & { level?: number }
>;

const initialMargin = 56;
const stepMargin = 28;

export const HierarchyNameCellRenderer: React.FC<THierarchyNameCellRenderer> = (props) => {
    const { value, data } = props;

    const style = useMemo(() => {
        if (data && Number.isInteger(data?.level)) {
            return { marginLeft: !data.level ? initialMargin : initialMargin + stepMargin * data.level };
        }

        return undefined;
    }, [data]);

    return <span style={style}>{value}</span>;
};

HierarchyNameCellRenderer.displayName = 'HierarchyNameCellRenderer';
